import React from 'react';
import ListGroup from "react-bootstrap/ListGroup";

const TypeBar = ({categories, selectedCategory, setSelectedCategory, selectedType}) => {
    // Фильтруем категории по выбранному типу
    const filteredCategories = selectedType ? categories.filter(cat => cat.type === selectedType) : categories;
    return (
        <ListGroup>
            {filteredCategories.map(category =>
                <ListGroup.Item
                    style={{cursor: 'pointer'}}
                    active={category.id === selectedCategory?.id}
                    onClick={() => setSelectedCategory(category)}
                    key={category.id}
                >
                    {category.name}
                </ListGroup.Item>
            )}
        </ListGroup>
    );
};

export default TypeBar;